export default "__VITE_ASSET__DZU3GxM___"